/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.auth.di

import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import studio.oddpods.cauce.feature.auth.LandingViewModel
import studio.oddpods.cauce.feature.auth.OtpViewModel

val AuthModule = module {
    viewModelOf(::LandingViewModel)
    viewModel { (email: String) -> OtpViewModel(email = email, authService = get()) }
}
